module.exports = __webpack_public_path__ + "s/img/Play_M_2.7c82b77b.jpg";